import { Controller } from "@hotwired/stimulus"
import { loadGoogleMaps } from "../lib/google_maps"

// Renders a Google Map centered on an approximate area (department/region),
// geocoded from a text query. Falls back to the placeholder when the API key
// is missing or the location can't be geocoded.
export default class extends Controller {
  static targets = ["canvas", "placeholder"]
  static values = { apiKey: String, query: String }

  connect() {
    if (!this.apiKeyValue || !this.queryValue) return
    loadGoogleMaps(this.apiKeyValue).then(() => this.#render())
  }

  #render() {
    const geocoder = new google.maps.Geocoder()
    geocoder.geocode({ address: this.queryValue }, (results, status) => {
      if (status !== "OK" || !results || !results[0]) return

      const position = results[0].geometry.location
      const map = new google.maps.Map(this.canvasTarget, {
        center: position,
        zoom: 9,
        disableDefaultUI: true,
        zoomControl: true,
        clickableIcons: false,
      })
      new google.maps.Marker({ map, position })

      if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
    })
  }
}
